export enum CenterUnosDataRowValueType{
    DeceasedDonor = 1,
    LivingDonor = 2,
    UnosNdd = 3,
    UnosKpd = 4,
    DeceasedDonorWaitList = 5,
    DeceasedDonorActiveWaitList = 6
}